module.exports = __webpack_public_path__ + "img/3057579A8D69CDA55727B63237FA1893.3057579a.png";